import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import axios from "axios";
import jwt_decode from "jwt-decode";
import React from "react";
import ReactDOM from "react-dom";
import { I18nextProvider } from "react-i18next";

import App from "./App";
import { logout } from "./components/app-header/UserProfile/UserProfile.utils";
import AppErrorBoundary from "./components/error-boundary/AppErrorBoundary";
import { translationUtil } from "./i18";
import fetchEnv from "./utils/FetchEnv";
import { msalConfig } from "./utils/MSLoginConfig";
const msalInstance = new PublicClientApplication(msalConfig);

axios.interceptors.request.use(
  (request) => {
    const jwtToken = JSON.parse(localStorage.getItem("loginResponse"))?.object?.jwt;
    const userID = JSON.parse(localStorage.getItem("loginResponse"))?.object?.username;
    const tenantId = localStorage.getItem("tenantId");
    const applicationName = localStorage.getItem("applicationName");
    const sessionTokenResponse = JSON.parse(JSON.stringify(jwt_decode(jwtToken)));
    const productSubscriptionKey = sessionTokenResponse?.subscriptionKey ?? "";
    const tenantUUID = sessionTokenResponse?.tenantUUID || null;
    const productCategory = sessionStorage.getItem("productCategory") ?? "";
    const authSubscriptionKey = fetchEnv()?.REACT_APP_AUTH_SUBSCRIPTION_KEY;
    let subscriptionKey = "";
    if (request.url.includes("authservice")) {
      subscriptionKey = authSubscriptionKey;
    } else {
      subscriptionKey = productSubscriptionKey;
    }
    let headers = {
      Authorization: jwtToken,
      "Accept-Language": "en",
      "Content-Type": "application/json",
      Accept: "application/json",
      tenantID: tenantId,
      product: "msafety",
      tenantUUID: tenantUUID,
      applicationName: applicationName,
      userID,
      "Ocp-Apim-Subscription-Key": subscriptionKey,
      productCategory: productCategory,
    };
    request.headers = headers;
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      logout();
    }
    return Promise.reject(error);
  }
);

ReactDOM.render(
  <MsalProvider instance={msalInstance}>
    <I18nextProvider i18n={translationUtil}>
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    </I18nextProvider>
  </MsalProvider>,
  document.getElementById("root")
);
